// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CalcFormRadioButton_wrapper__khuW9","label":"CalcFormRadioButton_label__aE8SQ","input":"CalcFormRadioButton_input__TJFId"};